import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BackArrowIcon2,
  LoginAlpa,
  New_ScrollX2025,
  Star_particles,
} from "../../assets/icons";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";
import {
  forgotPassword,
  resndOTP,
  verifyOTP,
} from "../../Redux/actions/authActions";
import "./FP.css";
import VerifyOTPModal from "./VerifyOtp";
import { CgSpinner } from "react-icons/cg";

export default function ForgotPassword({ path }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOtpSuccess, setIsOtpSuccess] = useState(false);
  const [otp, setOpt] = useState("");
  const [inValidOtp, setInValidOtp] = useState("");
  const [inValid, setInValid] = useState("");
  const [otpType, setOtpType] = useState("");
  const [submitSuccessLoading, setSubmitSuccessLoading] = useState(false);

  // Get OTP
  const submitHandler = async (e) => {
    setSubmitSuccessLoading(true);
    e.preventDefault();
    try {
      const res = await dispatch(forgotPassword(email));
      if (res?.success) {
        setIsOtpSuccess(true);
        setOtpType(res?.otpType);
        setInValidOtp(" ");
      } else {
        setInValidOtp(res?.response?.data.message);
      }
      setSubmitSuccessLoading(false);
    } catch (error) {
      setSubmitSuccessLoading(false);
    }
  };

  const handleSubmitOtp = async (e) => {
    e.preventDefault();
    if (otp.length === 0) {
      return toast.error("Please enter a 6-digit OTP and Password field.", {
        position: "top-center",
      });
    } else if (otp.length > 0) {
      if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
        return toast.error("Please enter a valid 6-digit OTP.", {
          position: "top-center",
        });
      }

      if (!password && !confirmPassword) {
        return toast.error("Both password fields are required.", {
          position: "top-center",
        });
      }

      if (!password && confirmPassword) {
        return toast.error("Please enter the new password.", {
          position: "top-center",
        });
      }

      if (password && !confirmPassword) {
        return toast.error("Please enter the confirm password.", {
          position: "top-center",
        });
      }

      if (password !== confirmPassword) {
        return toast.error("Passwords do not match.", {
          position: "top-center",
        });
      }
    }

    if (otp && password === confirmPassword) {
      setSubmitSuccessLoading(true);
      const res = await dispatch(verifyOTP(email, otp, otpType, password));
      if (
        res?.status === 200 &&
        res?.data === "Password updated successfully"
      ) {
        setIsOtpSuccess(false);
        localStorage.removeItem("authToken");
        setOpt("");
        setInValidOtp("");
        setInValid("");
        navigate("/");
        setTimeout(() => {
          toast(
            <CustomToast title="" content="Password updated successfully !" />,
            defaultcustomToatStyle
          );
        }, 300);
        setSubmitSuccessLoading(false);
      } else if (res?.response?.data === "Invalid otp") {
        setInValid(res?.response?.data);
        setTimeout(() => {
          setInValid("");
        }, 5000);
        navigate("/");
        setTimeout(() => {
          toast(
            <CustomToast
              title=""
              content="Please enter a valid 6 digit otp."
            />,
            defaultcustomToatStyle
          );
        }, 300);
        setSubmitSuccessLoading(false);
      }
    }
  };

  const handleResendOtp = async () => {
    const res = await dispatch(resndOTP());
    if (res?.data?.message === "otp Resent successsful") {
      setInValid(`OTP Resent Check Your Mail Agian`);

      setTimeout(() => {
        setInValid("");
      }, 5000);
      toast.error("OTP Resent Check Your Mail Agian.", {
        position: "top-center",
      });
    }
  };

  // Remove token on component mount
  useEffect(() => {
    localStorage.removeItem("authToken");

    const handleBeforeUnload = () => {
      localStorage.removeItem("authToken");
    };

    // Add event listener for page refresh
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Check if token exists on navigation
    const checkAuthToken = () => {
      if (localStorage.getItem("authToken")) {
        localStorage.removeItem("authToken");
      }
    };

    // Run check on component mount
    checkAuthToken();

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="main_div">
      <div className="w-full h-full flex ForgetScale">
        <div className="lg:w-[45%] loginRight-block flex justify-center items-center bg-[#1e1f2a] ">
          {isOtpSuccess && (
            <VerifyOTPModal
              isOtpSuccess={isOtpSuccess}
              setIsOtpSuccess={setIsOtpSuccess}
              otp={otp}
              setOpt={setOpt}
              handleSubmitOtp={handleSubmitOtp}
              handleResendOtp={handleResendOtp}
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setconfirmPassword={setconfirmPassword}
              inValid={inValid}
              submitSuccessLoading={submitSuccessLoading}
            />
          )}
          <div className=" w-[57%] h-1/2 flex flex-col justify-center items-center relative">
            <img
              className="w-[350px] absolute left-[-40%] top-[-5%]"
              src={Star_particles}
              alt=""
            />
            <div className="flex items-center w-[90%] text-4xl manrope-600 text-white">
              <div className="ml-[-14%] pr-[7%]">
                <Link to="/login" className="cursor-pointer z-999">
                  <img
                    className="pl-[14px] w-[27px]"
                    src={BackArrowIcon2}
                    alt="Back"
                  />
                </Link>
              </div>
              Reset Password
            </div>
            <form className="w-[90%]" onSubmit={submitHandler}>
              <div className="mb-6 mt-6 ">
                {/* <label htmlFor="email" className="label_text ">Email address</label> */}
                <input
                  type="email"
                  id="email"
                  className="input_blockFP manrope-400 w-[90%]"
                  placeholder="Enter email ID"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <p className="inValidOtpFP">{inValidOtp ? inValidOtp : null}</p>
              <div className="flex w-full justify-end submit-box">
                <div className="login_div_2 w-full">
                  <button
                    type="submit"
                    className="Login_btn text-lg flex items-center justify-center gap-4 relative"
                  >
                    Submit
                    {submitSuccessLoading && (
                      <CgSpinner className="animate-spin text-[1.1rem]" />
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* Right Block */}
        <div className="lg:w-[55%] bg-[#0a0a0a] flex flex-col justify-center items-center ">
          <div className="w-[55%] h-[63%] text-white">
            <div>
              <div className="flex pt-2 pb-3 items-center">
                <img className="w-[35px]" src={New_ScrollX2025} alt="icon" />
                <span className="ml-[10px] Syne text-xl font-light tracking-wide manrope-600">
                  ScrollX.io
                </span>
              </div>
              <h1 className="pt-2 pb-4  text-[33px] manrope-400">
                <span className="manrope-800">ScrollX.io</span>, the simplest
                way <br /> to create your end credits
              </h1>
              <p className="text-base manrope-400">
                Generate stunning, production-ready end credits that are
                beautifully styled and perfectly structured—ready to use
                <br />
                within minutes.
              </p>
            </div>
            <div className="mt-[14px]">
              <img
                className="scale-x-[-1]  object-cover "
                src={LoginAlpa}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
